import { gql } from '@apollo/client'

export const REMOVE_MEMBER_FROM_GROUP_MUTATION = gql`
  mutation ($groupId: String!, $profileId: String!){
    removeGroupMember(request:  {groupId: $groupId, profileId: $profileId})
  }
`
